import { render, staticRenderFns } from "./destineList.vue?vue&type=template&id=44ed9f48&scoped=true&"
import script from "./destineList.vue?vue&type=script&lang=js&"
export * from "./destineList.vue?vue&type=script&lang=js&"
import style0 from "./destineList.vue?vue&type=style&index=0&id=44ed9f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed9f48",
  null
  
)

export default component.exports